import API from './API';

export default class Servico extends API {

  static get() {
    return super.get(`/configuracao`);
  }

  static editar(dados){
    return super.put(`/configuracao`, dados);
  }

  static get_web() {
    return super.get(`/ws/informacoes`);
  }

}



// WEBPACK FOOTER //
// ./src/services/api/Configuracao.js